import { v4 } from 'uuid'
import CitationStorage from './CitationStorage';

/**
 * API Mock, which uses MS document settings as a data storage
 */
export default class DataApi {

  constructor() {
    this.citationStorage = new CitationStorage()
  }

  /* stubs in case this is called by someone who expects the real data api */
  setDataPath() {
  }

  setTokenStorage() {
  }

  getProject() {
  }

  createProject() {
  }

  updateProjectName(project, name) {
  }

  saveCitation(url, citation) {
  }

  getCitation(projectId, citationId) {
  }

  getUser() {
  }

  deleteProject(url) {
  }

  getCitationCount() {
  }

  /**
   * Update a project to use another citation style
   * @param {Object} project the project to update
   * @param {string} style the new style for the project
   * @return {Promise<Object, Object>} the updated project or error if failed
   */
  updateProjectStyle(project, style) {
    console.log("change project style", project, style)
    return Promise.resolve({
      data: this.citationStorage.updateProjectStyle(project.id, style),
      links: []
    })
  }
  /**
   * Get all projects of the user
   * @return {Promise<Object[], Object>} a list of projects or error if failed
   */
  getProjects() {
    console.log("API get projects")
    const halProjects = []
    const projects = this.citationStorage.getProjects()
    for (let id in projects) {
      halProjects.push({
        data: projects[id],
        links: [
          {
            rel: 'author',
            type: 'application/vnd.com.easybib.data+json',
            href: 'https://data.playground.easybib.com/user/',
            title: 'EasyBib TestMbp'
          },
        ]
      })
    } 
    return Promise.resolve({
      data: halProjects,
      links: []
    })
  }

  /**
   * Add a citation to a project
   * @param {Object} project the project to update
   * @param {Object} citation the citation to add to the project
   * @return {Promise<Object, Object>} the added citation or error if failed
   */
  addCitationToProject(project, citation) {
    console.log("API add citation to project", project, citation)
    // const cleanedCitation = cleanUpCitation(citation)
    const cleanedCitation = citation
    const id = v4()
    cleanedCitation.data.id = id
    this.citationStorage.addCitation(cleanedCitation.data)
    cleanedCitation.links = [
      {
        rel: 'me',
        type: 'application/vnd.com.easybib.data+json',
        href: id,
        title: 'The blue'
      }
    ]
    return Promise.resolve(cleanedCitation)
  }


  /**
   * Get all citations of a given project
   * @param {Object} project - project to get citations of
   * @param {String} style - (optional) style the citations should be formatted in
   * @return {Promise<Object[], Object>} the list of citations or error if failed
   */
  getCitations(project, style) {
    console.log("API get citations", project, style)
    const citations = this.citationStorage.getCitations()
    return Promise.resolve(
      {
        data: citations.map(citation => ({ data: citation, links: [
          {
            rel: 'me',
            type: 'application/vnd.com.easybib.data+json',
            href: citation.id,
            title: 'The blue'
          }
        ]})),
        links: []
      }
    )
  }


  /**
   * Delete a citation
   * @param {String} url the url of the citation to delete
   * @return {Promise<String, Object>} empty string or error if failed
   */
  deleteCitation(url) {
    console.log("API delete citation", url)
    this.citationStorage.deleteCitation(url)
    return Promise.resolve()
  }
}



// WEBPACK FOOTER //
// ./src/fakeDataApi.js